import { Injectable } from "@angular/core";
import { ValidationErrors } from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class ErrorMessageNotifierService {
  public getErrorMessages(formControlErrors: ValidationErrors): string {
    const errorMessage = formControlErrors.required
      ? "Please enter a value."
      : formControlErrors.maxlength
      ? "The value must not exceed " +
        `${formControlErrors.maxlength.requiredLength}` +
        " characters."
      : formControlErrors.min
      ? "The value must be greater than or equal to " +
        `${formControlErrors.min.min}.`
      : formControlErrors.max
      ? "The value must be less than or equal to " +
        `${formControlErrors.max.max}.`
      : null;

    if (!errorMessage) {
      for (const key of Object.keys(formControlErrors)) {
        if (formControlErrors[key]) {
          return formControlErrors[key];
        }
      }
    }

    return errorMessage;
  }
}
